import InputMask from 'react-input-mask';
import styled from 'styled-components';

import { FormFieldWrapper } from '@/shared/ui/form/form-field/styles';
import { Label } from '../phone-field/styles';

const BankCardInput = styled(InputMask)`
  width: 100%;
  border: none;
  background: none;
  display: flex;
  height: 48px;
  min-width: 180px;
  padding: 8px 8px 8px 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: rgba(39, 38, 43, 0.6);
  color: #afafaf;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */

  &:hover {
    // background: #27262B;
    opacity: 0.9;
  }

  &:focus {
    // border: 1px solid var(--8-a-99-bd, #AFAFAF);
    // background: var(--2-c-344-a-40, #27262B);
  }

  &::placeholder {
    color: rgba(106, 123, 169, 0.6);
  }

  ${({ $error }) =>
    $error &&
    `
    border: 1px solid #da4444;

    &:hover {
      border: 1px solid #da4444;
    }

    &:focus {
      border: 1px solid #da4444;
    }
  `}

  ${({ $valid }) =>
    $valid &&
    `
    border: 1px solid #08AD5E;

    &:hover {
      border: 1px solid #08AD5E;
    }

    &:focus {
      border: 1px solid #08AD5E;
    }
  `}
`;

export { FormFieldWrapper, BankCardInput, Label };
